import request from './http'

//地址统计
export function getAddress(data) {
    return request({
      url: `/marketall/btc/rt/address`,
      method: 'post',
      data
    })
  }

  //交易费 
export function getBTCFees(data) {
    return request({
      url: `/marketall/btc/rt/BTCFees`,
      method: 'post',
      data
    })
  }

    //交易量 
export function getBTCVolume(data) {
    return request({
      url: `/marketall/btc/rt/BTCVolume`,
      method: 'post',
      data
    })
  }

    //交易量(消除找零)
export function getEaVolume2(data) {
    return request({
      url: `/marketall/btc/rt/eaVolume`,
      method: 'post',
      data
    })
  }
//每日已实现盈利交易占比
export function getProfitRate2(data) {
    return request({
      url: `/marketall/btc/rt/profitRate`,
      method: 'post',
      data
    })
  }


  //已花费输出盈利比 
export function getSopr2(data) {
    return request({
      url: `/marketall/btc/rt/sopr`,
      method: 'post',
      data
    })
  }

    //已花费输出平均寿命
export function getAsol2(data) {
    return request({
      url: `/marketall/btc/rt/asol`,
      method: 'post',
      data
    })
  }

//已花费输出休眠平均天数
export function getDormancy2(data) {
    return request({
      url: `/marketall/btc/rt/dormancy`,
      method: 'post',
      data
    })
  }

  
//币天销毁量
export function getCdd2(data) {
    return request({
      url: `/marketall/btc/rt/cdd`,
      method: 'post',
      data
    })
  }

  //币天销毁量年龄分布
export function getSoag2(data) {
    return request({
      url: `/marketall/btc/rt/soag`,
      method: 'post',
      data
    })
  }

